import { CITATION_HEADINGS_PREFIX } from "../../constants/config";
// import { Modal } from "antd";
import { AppStateContext } from "../../state/AppProvider";
import { useContext } from "react";
import { CitationDisplayTypes } from "../../constants/enums"
interface CitationListItemProps {
    citation: SearchResultCitation
    citationNos: number[];
    // openReferencesModal: boolean
    // selectedReferences: SearchResultCitation | undefined
    setSelectedReferences: (reference: SearchResultCitation | undefined) => void
    setOpenReferencesModal: (open: boolean) => void
    // screeSize: number
}

const CitationListItem: React.FC<CitationListItemProps> = (props: CitationListItemProps) => {
    const appStateContext = useContext(AppStateContext)

    const openUrlInNewWindow = (url: string) => {
        window.open(url, 'ECKEIL', 'width=800,height=600,top=100,left=100')
        return false;
    };


    return (
        <>

            {appStateContext?.state?.screenSize !== undefined && appStateContext.state.screenSize > 2 &&
                <div key={props.citation.no} className='citation-section br-16 p-3 bg-reference-item'
                    style={{ wordWrap: 'break-word', cursor: 'pointer' }}
                    onClick={() => {
                        props.setSelectedReferences(props.citation);
                        props.setOpenReferencesModal(true);
                    }}>
                    <div
                        className='fs16-fw600 c-offmain pb-1'>
                        {props.citationNos.map(no => `[${no}]`).join('')} {props.citation.main_title}
                    </div>
                    {props.citation.display_type === CitationDisplayTypes.FULL || props.citation.display_type === CitationDisplayTypes.MAIN_TITLE_WITH_SUBTITLE || props.citation.display_type === CitationDisplayTypes.CUSTOM_URL ? (
                        <div className='fs16-fw600 c-offmain pb-1'>
                            {CITATION_HEADINGS_PREFIX}
                            {decodeURIComponent(props.citation.title ?? '')}
                        </div>
                    ) : null}
                    {props.citation.display_type === CitationDisplayTypes.FULL || props.citation.display_type === CitationDisplayTypes.MAIN_TITLE_WITH_URL ? (
                    <div className='fs14-fw500 c-offmain pb-1 t-underline'
                        onClick={(e) => {
                        e.stopPropagation();
                        const decodedUrl = decodeURIComponent(props.citation.encoded_url ?? "");
                        const fileName = decodedUrl.split("/").pop();
                        if (fileName) {
                            const localPath = `/documents/${encodeURIComponent(fileName)}`;
                            window.open(localPath, "_blank");
                        }
                        }}
                    >
                        {decodeURIComponent(props.citation.encoded_url ?? '')}
                    </div>
                    ) : null}
                    {props.citation.display_type === CitationDisplayTypes.CUSTOM_URL ? (
                        <div className='fs14-fw500 c-offmain pb-1 t-underline'><u>{decodeURIComponent(props.citation.url ?? '')}</u></div>
                    ) : null}

                    <div className='fs14-fw400 c-default'>
                        {props.citation.content.trim().length > 200 ? (
                            <>
                                {props.citation.content.trim().substring(0, 200).split('\n').map((line, index, array) => (
                                    <span key={index}>
                                        {line}
                                        {index !== array.length - 1 ? <br /> : '...'}
                                    </span>
                                ))}
                            </>
                        ) : (
                            props.citation.content.trim().split('\n').map((line, index) => (
                                <span key={index}>{line}<br /></span>
                            ))
                        )}
                    </div>
                </div>
            }


        </>
    )
}

export default CitationListItem